import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lightbulb, Award, Users, Leaf } from 'lucide-react';
export function TrustBadges() {
  const badges = [{
    icon: <Shield size={32} strokeWidth={1.5} data-id="element-88" />,
    label: 'Integrity'
  }, {
    icon: <Lightbulb size={32} strokeWidth={1.5} data-id="element-89" />,
    label: 'Innovation'
  }, {
    icon: <Award size={32} strokeWidth={1.5} data-id="element-90" />,
    label: 'Quality Assurance'
  }, {
    icon: <Users size={32} strokeWidth={1.5} data-id="element-91" />,
    label: 'Safety First'
  }, {
    icon: <Leaf size={32} strokeWidth={1.5} data-id="element-92" />,
    label: 'Sustainability'
  }];
  return <section className="py-12 sm:py-16 md:py-20 bg-white border-y border-border" data-id="element-93">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 sm:gap-8 md:gap-12" data-id="element-95">
          {badges.map((badge, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center" data-id="element-96">
              <div className="text-gold mb-3 sm:mb-4" data-id="element-97">{badge.icon}</div>
              <span className="font-medium text-charcoal text-sm sm:text-base" data-id="element-98">
                {badge.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}